// Studyo Today Backend
// Package studyo.today.type
// Resource definitions
// Copyright (c) 2015-2021 Intuitic Inc.

// @generated by protoc-gen-es v2.2.5 with parameter "import_extension=js"
// @generated from file studyo/today/type/relative_date.proto (package studyo.today.type, syntax proto3)
/* eslint-disable */

import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv1";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import { file_studyo_today_type_relative_date_kind } from "./relative_date_kind_pb.js";

/**
 * Describes the file studyo/today/type/relative_date.proto.
 */
export const file_studyo_today_type_relative_date = /*@__PURE__*/
  fileDesc("CiVzdHVkeW8vdG9kYXkvdHlwZS9yZWxhdGl2ZV9kYXRlLnByb3RvEhFzdHVkeW8udG9kYXkudHlwZSJ/CgxSZWxhdGl2ZURhdGUSKAoEZGF0ZRgBIAEoCzIaLmdvb2dsZS5wcm90b2J1Zi5UaW1lc3RhbXASMQoEa2luZBgCIAEoDjIjLnN0dWR5by50b2RheS50eXBlLlJlbGF0aXZlRGF0ZUtpbmQSEgoKdW5pdF9jb3VudBgDIAEoBUIZqgIWU3R1ZHlvLlRvZGF5LkdycGMuVHlwZWIGcHJvdG8z", [file_google_protobuf_timestamp, file_studyo_today_type_relative_date_kind]);

/**
 * Describes the message studyo.today.type.RelativeDate.
 * Use `create(RelativeDateSchema)` to create a new message.
 */
export const RelativeDateSchema = /*@__PURE__*/
  messageDesc(file_studyo_today_type_relative_date, 0);

